import './Spinner.scss';

export function Spinner() {
  return <span className="Spinner">
    <i className="icon icon-xs">refresh</i>
  </span>
}
